import React from "react";

export const CoreLayout = (props) => {
  //core layout as a wrapper for authenticated users
  return <>{props.children}</>;
};
